import React from "react";
import {
  EventPicsData,
  KavynjaliPicsData,
  anchoringPicsData,
  newKavynjaliPicsData,
  newAnchoringPicsData,
  stagePicsData,
} from "./EventPicsData";
import "./EventPicsCSS.css";
import { PhotoGallery } from "../../components";
import PhotoGallery2 from "../../components/PhotoGallery/PhotoGallery2";
import "bear-react-carousel/dist/index.css";

export const EventPics = () => {
  // return <PhotoGallery2 />;
  return (
    <div className="flex flex-col items-center space-y-4 divide-y-4 justify-center">
      <div className="glory-container">
        <h1 className="eventHeading">काव्यांजलि</h1>
        <PhotoGallery columns={4} photos={newKavynjaliPicsData} />
      </div>
      <div className="glory-container">
        <h1 className="eventHeading">मंच संचालन</h1>
        <PhotoGallery photos={newAnchoringPicsData} />
      </div>
      <div className="glory-container">
        <h1 className="eventHeading">मंच प्रस्तुति</h1>
        <PhotoGallery photos={stagePicsData} columns={3} />
      </div>
    </div>
  );

  //   return (
  //     <div className="services-section space-y-40 ">
  //       {/* <h1 className="eventHeading"></div>h1}
  //       <Element data={KavynjaliPicsData} heading={"काव्यांजलि"} />
  //       <Element data={anchoringPicsData} heading={"मंच संचालन"} />
  //       <Element data={EventPicsData} heading={"कौशल वृद्धि कार्यशाला"} />
  //     </div>
  //   );
  // };
  // const Element = ({ data, heading }) => {
  //   return (
  //     <h1
  //       className="hs"
  //       style={{
  //         zIndex: 100,
  //         width: "100%",
  //         fontWeight: "bold",
  //         // backgroundColor: "rgba(0,0,0,0.1)",
  //         lineHeight: "70px",
  //         color: "white",
  //       }}
  //     >
  //       <div className="services-heading">{heading || ""}</div>
  //       <div className="services">
  //         {data.map((item, index) => {
  //           return (
  //             <figure className="services-cell" key={index}>
  //               <img
  //                 className="services-cell_img"
  //                 alt=""
  //                 key={index}
  //                 src={item.imgSrc}
  //               />
  //             </figure>
  //           );
  //         })}
  //       </div>
  //     </h1>
  //   );
};
